export function getParameters() {
  const url = new URL(location.href);
  const releaseIdString = url.searchParams.get('release_id');
  const companyIdString = url.searchParams.get('company_id');
  if (releaseIdString !== null && companyIdString !== null) {
    const releaseId = Number(releaseIdString);
    const companyId = Number(companyIdString);
    if (Number.isNaN(releaseId) || Number.isNaN(companyId)) {
      throw new TypeError(
        'Invalid URL, releaseId and companyId must be number',
      );
    }

    return {page: 'preview' as const, releaseId, companyId};
  }

  // /draft/9327f29364e16577f257520ce218 のようなパスからパスパラメータを取得
  const previewPageKey = url.pathname.split('/').pop();
  if (previewPageKey !== '' && previewPageKey !== undefined) {
    return {page: 'external-preview' as const, previewPageKey};
  }

  throw new Error('Invalid URL');
}

function isMobileDevice() {
  return /iPhone|Android.+Mobile/.exec(navigator.userAgent) !== null;
}

export function showMobileExternalPreview() {
  const {page: pageType} = getParameters();
  const isMobile = isMobileDevice();

  return isMobile && pageType === 'external-preview';
}
